import React, { useState } from "react";
import Slider from "rc-slider";

import "rc-slider/assets/index.css";
import styled from "styled-components";
import { Icon } from "../Table/tableComponents";
import HumidityCalculatorDialog from "./HumidityCalculatorDialog";

const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 90%;
`;

const SliderContainer = styled.div`
  margin-top: 32px;
`;

const Percentage = styled.p`
  font-size: 21px;
  margin: 5px;
`;

const SandSlider = ({
  title,
  value,
  onChangeSlider,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const onClose = () => setIsOpen(false);

  return (
    <React.Fragment>
      <InfoContainer>
        <h1>
          {title}
        </h1>
        <Percentage>
          {` ${value}%`}
        </Percentage>
        <Icon className="fas fa-calculator" onClick={() => setIsOpen(true)} />
      </InfoContainer>
      <SliderContainer>
        <Slider
          value={value}
          vertical={false}
          step={0.1}
          onChange={e => onChangeSlider(e)}
          max={20}
          min={0}
        />
      </SliderContainer>
      {isOpen && (
        <HumidityCalculatorDialog
          isOpen={isOpen}
          onClose={onClose}
          onCalculate={(v) => onChangeSlider(v)}
        />
      )}
    </React.Fragment>
  );
};

export default SandSlider;
